import { useQuery } from '@tanstack/react-query';
import { procedureExecutionService } from '../services/procedure-execution.service';

export const procedureExecutionKeys = {
  execution: (inspectionId: string) => ['procedure-execution', inspectionId] as const,
  stepContent: (inspectionId: string, stepExecId: string) =>
    ['procedure-execution', inspectionId, 'step', stepExecId, 'content'] as const,
  stepEvidence: (inspectionId: string, stepExecId: string) =>
    ['procedure-execution', inspectionId, 'step', stepExecId, 'evidence'] as const,
  stepComments: (inspectionId: string, stepExecId: string) =>
    ['procedure-execution', inspectionId, 'step', stepExecId, 'comments'] as const,
};

export function useProcedureExecution(inspectionId: string) {
  return useQuery({
    queryKey: procedureExecutionKeys.execution(inspectionId),
    queryFn: () => procedureExecutionService.getExecution(inspectionId),
    staleTime: 15_000,
    enabled: !!inspectionId,
    retry: (count, error) => {
      const e = error as { response?: { status?: number } };
      if (e?.response?.status === 404) return false;
      return count < 2;
    },
  });
}

export function useStepContent(inspectionId: string, stepExecId: string, enabled: boolean) {
  return useQuery({
    queryKey: procedureExecutionKeys.stepContent(inspectionId, stepExecId),
    queryFn: () => procedureExecutionService.getStepContent(inspectionId, stepExecId),
    staleTime: 5 * 60 * 1000,
    enabled: enabled && !!inspectionId && !!stepExecId,
  });
}
